import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";
import { money, resetLabel } from "../lib/budgetTime";

// What happens to the gate when today's budget changes, spelled out before the owner confirms.
const gateNote = (gate, amount) => {
  if (!gate?.paused) return null;
  if (gate.paused_by === "auto" && amount > (gate.spent_usd || 0)) return "The gate paused because today's budget ran out. This re-opens it.";
  return "The gate stays paused. Raising the budget does not undo your pause or the start-of-day pause.";
};

export const TodayBudgetConfirm = ({ gate, amount, busy, onCancel, onConfirm }) => {
  const note = gateNote(gate, amount);
  return (
    <AlertDialog open={amount !== null} onOpenChange={(open) => !open && !busy && onCancel()}>
      <AlertDialogContent data-testid="today-budget-confirm">
        <AlertDialogHeader>
          <AlertDialogTitle>Set today's budget to {money(amount)}?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2 text-sm">
              <p data-testid="today-budget-confirm-change">From {money(gate?.budget_usd)} to {money(amount)}. Spent so far: {money(gate?.spent_usd)}.</p>
              {amount > (gate?.cap_usd ?? Infinity) && (
                <p data-testid="today-budget-confirm-above-cap" className="font-semibold text-amber-800">
                  This is above the {money(gate.cap_usd)} single-unpause cap. Only this control can go higher, never above {money(gate.override_max_usd)}.
                </p>
              )}
              {note && <p data-testid="today-budget-confirm-gate">{note}</p>}
              <p data-testid="today-budget-confirm-reset">Valid for today only: it {resetLabel(gate?.resets_at)}. The owner address gets an email.</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="today-budget-confirm-cancel" disabled={busy}>Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="today-budget-confirm-ok" disabled={busy} onClick={(e) => { e.preventDefault(); onConfirm(); }}>
            Yes, set {money(amount)}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
